module.exports = __webpack_public_path__ + "f67923456e829cebc19f443efb1471d2.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Tutors/images/img_tutor_rocket.svg
// module id = 1608
// module chunks = 8